import React from 'react'

const InsuranceStatus = () => {
  return (
    <div className="bg-white p-4 shadow-md rounded-lg">
      <h2 className="text-2xl font-semibold mb-4">Transaction With Insurance</h2>
      <p className="text-gray-700">
        Your transaction has been handed over to Insurance Team.
      </p>
    </div>
  )
}

export default InsuranceStatus